import { Box, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useEffect, useState } from 'react';
import SearchField from 'src/shared/components/form/searchField';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { AssociationStatusEnum } from 'src/shared/models/enums/associationStatus.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { AssociationDataGrid } from '../components/associationDataGrid';
import { AssociationSearchFilter } from '../models/associationSearchFilter';
import { AssociationStatusItem } from '../models/associationStatusItem';
import { AssociationStatuses } from '../components/associationStatuses';

export const AssociationListPage = () => {
  const { t } = useTranslation(['association']);
  const isMounted = useIsMounted();

  const statusFields: AssociationStatusItem[] = [
    { label: t('association:active'), key: AssociationStatusEnum.Active, values: AssociationStatusEnum.Active },
    { label: t('association:inActive'), key: AssociationStatusEnum.Inactive, values: AssociationStatusEnum.Inactive },
  ];

  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [status, setStatus] = useState<AssociationStatusItem[]>(statusFields);

  const [associationSearchFilter, setAssociationSearchFilter] = useState<AssociationSearchFilter>({
    filter: '',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    sortCol: 'localAss',
    sortDir: 'asc',
    status: undefined,
  });

  useEffect(() => {
    if (isMounted()) {
      if (status.length === 1) {
        const selectedValue = status[0].values;
        setAssociationSearchFilter((prev) => ({
          ...prev,
          status: selectedValue,
        }));
      } else {
        setAssociationSearchFilter((prev) => ({
          ...prev,
          status: undefined,
        }));
      }
    }
  }, [status, isMounted]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setAssociationSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setAssociationSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setAssociationSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, tempSearchString]);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader title={t('association:listAssociationHeader')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageFilterSection
            leftContent={
              <>
                <Box sx={{ marginBottom: { xs: 2, sm: 0 }, marginRight: { xs: 0, sm: 2 } }}>
                  <SearchField
                    initialValue={associationSearchFilter.filter}
                    onSearch={(newSearchString) => {
                      setSearchInitialized(true);
                      setTempSearchString(newSearchString);
                    }}
                  />
                </Box>
                <AssociationStatuses initialValue={statusFields.map((x) => x.key)} options={statusFields} callback={(val) => setStatus(val)} />
              </>
            }
          />
          <AssociationDataGrid
            searchFilter={associationSearchFilter}
            searchFilterCallback={(newFilter) =>
              setAssociationSearchFilter((prev) => ({
                ...prev,
                ...newFilter,
              }))
            }
          />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
